import { Component, AfterViewInit, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { Observable ,  Subscription  } from 'rxjs';

import { ApiError, MessageService } from '../../../core';
import { BaseTypeahead, BaseTypeaheadService } from '../../../core/services/typeahead';
import { NaturezaVenda } from '../natureza-venda';
import { NaturezaVendaTypeaheadHttpService } from './natureza-venda-typeahead-http.service';
import { NaturezaVendaFilter, NaturezaVendaFilterModalComponent } from '../filter';
import { isSituacaoInativa } from '../situacao';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';

@Component({
    selector: 'sgt-natureza-venda-typeahead',
    templateUrl: './natureza-venda-typeahead.component.html',
    styleUrls: ['./natureza-venda-typeahead.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => NaturezaVendaTypeaheadComponent), multi: true },
    ]
})
export class NaturezaVendaTypeaheadComponent implements OnInit, AfterViewInit, BaseTypeahead<NaturezaVenda> {
    @Input() entity: NaturezaVenda;
    @Output() ngModelChange = new EventEmitter<NaturezaVenda>();

    @Input() required: any;
    @Input() disabled: any;
    @Input() readonly: any;
    @Input() ngControl: NgControl;
    @Input() autofocus = false;
    @Input() dropup = false;
    @Input() typeaheadOptionsInScrollableView = 5; // Quantidade de itens visíveis no no scroll do typeahead
    @Input() container: string;
    @Output() typeaheadChange = new EventEmitter<NaturezaVenda>();
    @Output() entitySelected = new EventEmitter<NaturezaVenda>(); // Emite evento quando a entidade foi selecionada no typeahead
    @Output() clearEntity = new EventEmitter<any>();
    // Filters
    filter = new NaturezaVendaFilter();
    /** Situação padrão. Se informada sempre será considerada esta situação no filtro */
    @Input() situacao: number = null;

    @ViewChild('filterModal') filterModal: NaturezaVendaFilterModalComponent;
    @ViewChild('inputTypeahead', {static: true}) inputTypeahead: ElementRef;
    typeaheadOptionsLimit = 1000; // Quantidade máxima de registros exibidos no typeahead
    typeaheadSelected: string;
    typeaheadToken: string;
    typeaheadDataSource: Observable<NaturezaVenda[]>;
    typeaheadNoResults: boolean;

    currentRequest: Subscription;
    isLoading: boolean;

    propagateChange: any = () => {};

    constructor(private baseTypeaheadService: BaseTypeaheadService,
                private messageService: MessageService,
                private naturezaVendaTypeaheadHttpService: NaturezaVendaTypeaheadHttpService) { }

    ngOnInit() {
        this.createDataSource();
    }

    ngAfterViewInit() {
        if (this.autofocus) {
            jQuery(this.inputTypeahead.nativeElement).trigger('focus');
        }
    }

    /** Cria o data source do typeahead */
    createDataSource() {
        this.typeaheadDataSource = Observable.create((observer: any) => {
            if (this.currentRequest) {
                this.currentRequest.unsubscribe();
            }

            this.setFilter(this.typeaheadToken);
            this.currentRequest = this.naturezaVendaTypeaheadHttpService.search(this.filter, this.typeaheadOptionsLimit)
                                        .subscribe(
                                            (entities: NaturezaVenda[]) => observer.next(entities),
                                            (error: ApiError) => {
                                                this.messageService.error(error.message, 'Ocorreu um erro ao pesquisar as naturezas de vendas. Tente novamente', error);
                                                observer.next([]);
                                            }
                                        );
        });
    }

    /** Seta os valores padrões e da pesquisa no filter para pesquisar as naturezas de vendas */
    private setFilter(filterPsq: string = null) {
        this.filter.clear();
        this.filter.filterPsq = filterPsq;
        this.filter.situacao = this.situacao;
    }

    /** Seta o foco no input */
    setFocus() {
        jQuery(this.inputTypeahead.nativeElement).focus();
    }

    /** Ao digitar no input do typeahead */
    onKeyup(e: KeyboardEvent) {
        this.baseTypeaheadService.onKeyup(this, e);
    }

    /** Ao sair do input do typeahead */
    onBlur() {
        this.baseTypeaheadService.onBlur(this);
        if (!this.entity) {
            this.clearEntity.emit();
        }
    }


    /** Verifica se o typeahead possui resultados */
    onChangeTypeaheadNoResults(noResults: boolean) {
        this.typeaheadNoResults = noResults;
    }

    /** Ao selecionar a natureza de venda no typeahead */
    onSelectEntity(tm: TypeaheadMatch) {
        this.baseTypeaheadService.onSelectEntity(this, tm);
        this.entitySelected.emit(this.entity);
    }

    /** Ao selecionar a natureza de venda no modal de pesquisa */
    onSelectEntityModal(naturezaVenda: NaturezaVenda) {
        if (naturezaVenda) {
            this.entity = naturezaVenda;
        } else {
            this.entity = null;
        }

        this.propagateChange(this.entity);
        this.typeaheadChange.emit(this.entity);
        this.entitySelected.emit(this.entity);
        this.writeValue(this.entity);
        jQuery(this.inputTypeahead.nativeElement).focus();
    }

    /** Abre o modal de pesquisa */
    search() {
        this.setFilter();
        this.filterModal.open(this.filter);
    }

    /** Limpa o typeahead e o model */
    clear() {
        this.baseTypeaheadService.clear(this);
        this.clearEntity.emit();
    }

   /** Quando recebe um objeto NaturezaVenda de "fora" do component */
    writeValue(value: NaturezaVenda) {
        if (value) {
            this.baseTypeaheadService.writeValue(this, value, value.nome);
        } else {
            this.baseTypeaheadService.writeValue(this, null);
        }
    }

    /** Propaga as alterações */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}

    /** Verifica se a situação da natureza de venda é Inativa */
    isSituacaoInativa(situacao: number): boolean {
        return isSituacaoInativa(situacao);
    }
}
